import { configureChains, createConfig, WagmiConfig } from "wagmi";
import { mainnet, syscoin } from "wagmi/chains";
import "@rainbow-me/rainbowkit/styles.css";

import { getDefaultWallets, RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { publicProvider } from "wagmi/providers/public";

const { chains, publicClient } = configureChains(
  [mainnet, syscoin],
  [publicProvider()]
);

const { connectors } = getDefaultWallets({
  appName: "Dune",
  projectId: String(process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID),
  chains,
});

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors: connectors(),
  publicClient,
});

export const Web3Provider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <WagmiConfig config={wagmiConfig}>
      <RainbowKitProvider chains={chains}>{children}</RainbowKitProvider>
    </WagmiConfig>
  );
};
